
import Main from './main.js';

const startCode = async () => {
  new Main();
}

startCode();